<template>
  <span>
      <i v-show="res" class="icon el-icon-circle-check right"></i>
      <i v-show="!res" class="icon el-icon-circle-close wrong"></i>
  </span>
</template>

<script>
  export default {
    name: 'RightOrWrongIcon',
    props: {
      res: Boolean,
    },
  }
</script>

<style scoped>
  .icon {
    font-size: 16px;
  }

  .right {
    color: #3dad00;
  }

  .wrong {
    color: red;
  }
</style>
